import React from 'react';
import { useSummary } from '../hooks';
import { useSelector } from 'react-redux';
import { selectPeriod } from '../state/filtersSlice';
import { PERIOD_LABELS, orderPair } from '../utils/periods';
import SuScreen from './home/SuScreen';
import SalesCard from './network/SalesCard';
import TrendChart from './network/TrendChart';

// Chart series colours are theme independent.
const SERIES_PURPLE = '#6c4cff';
const SERIES_BLUE = '#3b82f6';
const SERIES_AMBER = '#f5b82e';

const NetworkPage: React.FC = () => {
  const { data, loading, error, refetch } = useSummary();
  const net = data?.network ?? null;
  const lfl = data?.lfl ?? null;
  const busy = loading && !data;
  const period = useSelector((s: any) => selectPeriod(s));
  const shown = data?.period ?? period;
  const comparePeriod = data?.compare_period ?? null;

  const networkBars = (() => {
    if (!net) return [];
    if (!comparePeriod) return [{ label: `Network (${net.store_count})`, value: net.sales, color: SERIES_PURPLE }];
    const [first, second] = orderPair(shown, comparePeriod);
    const value = (p: typeof first) => (p === shown ? net.sales : net.compare_sales ?? 0);
    return [
      { label: `Network ${PERIOD_LABELS[first]}`, value: value(first), color: SERIES_AMBER },
      { label: `Network ${PERIOD_LABELS[second]}`, value: value(second), color: SERIES_PURPLE },
    ];
  })();
  const bars = [
    ...networkBars,
    ...(net && lfl ? [{ label: `LFL (${lfl.store_count})`, value: lfl.sales, color: SERIES_BLUE }] : []),
  ];

  return (
    <SuScreen storeCount={net?.store_count} onRefresh={refetch} error={error} hasData={!!data}>
      <SalesCard title="Network Sales" block={net} loading={busy} period={shown} comparePeriod={comparePeriod} />
      <SalesCard title="LFL Sales" block={lfl} unavailable={!!data && !lfl} loading={busy} period={shown} comparePeriod={comparePeriod} />
      <div className="su-card">
        <div className="su-card-title"><span>Network vs LFL Sales Trend</span></div>
        {busy ? (
          <div className="su-skeleton" style={{ height: 240 }} />
        ) : (
          <>
            <TrendChart data={bars} />
            {data && !lfl && <div className="su-note">LFL data coming soon</div>}
          </>
        )}
      </div>
    </SuScreen>
  );
};

export default NetworkPage;
